export default {
  snackbarQueue: state => state.snackbarQueue,
  snackbarCurrent: (state, getters) => getters.snackbarQueue[0],
  layout: state => state.layout,
};



// WEBPACK FOOTER //
// ./src/store/modules/app/getters.js